var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screenfull",on:{"click":_vm.click}},[_c('span',{staticClass:"screenfull_icon icon-zhankai",class:{'icon-shouqi': _vm.isFullscreen}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.isFullscreen?_vm.$ts('全屏'):_vm.$ts('正常')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6174c5a7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","audio":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Navbar/Screenfull.vue
// module id = null
// module chunks = 